// extracted by mini-css-extract-plugin
module.exports = {"login":"_3SZNV","tabs":"biV3F","prefixIcon":"MA4wo","getCaptcha":"_2PVRE","submit":"_1WKz7"};